import script from "./TgContactMsgWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./TgContactMsgWindow.vue?vue&type=script&lang=ts&setup=true"

import "./TgContactMsgWindow.vue?vue&type=style&index=0&id=256bceb2&lang=css"

const __exports__ = script;

export default __exports__